<template>
  <b-container class="pt-2">
    <b-table
        hover
        responsive
        :items="getDeliveryAddressList"
        :fields="fields"
        :current-page="deliveryAddressList.currentPage"
        :per-page="deliveryAddressList.perPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="table-bordered table-hover"
        show-empty>
      <template v-slot:empty="scope">
        <h6 class="text-center">Адреса доставки отсутствуют</h6>
      </template>
      <template v-slot:cell(interaction)="row">
        <b-button variant="outline-primary"
                  title="Просмотр"
                  @click="goToDetailPage(row.item.id)">
          <b-icon-eye-fill/>
        </b-button>
      </template>
      <template v-slot:table-busy>
        <loading-spinner/>
      </template>
    </b-table>
    <div class="d-flex">
      <div class="col-md-2 pl-0">
        <b-form-select
            v-model="deliveryAddressList.perPage"
            class="text-light border-secondary bg-secondary">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
        </b-form-select>
      </div>
      <span class="align-self-center d-none d-lg-block mb-2">записей на страницу</span>
      <b-pagination
          v-model="deliveryAddressList.currentPage"
          class="my-0 ml-auto mb-2"
          :total-rows="deliveryAddressList.totalCount"
          :per-page="deliveryAddressList.perPage"
          aria-controls="template-table"
          @input="getDeliveryAddressList">
      </b-pagination>
    </div>
  </b-container>
</template>
<script>
import deliveryAddressService from "@/modules/delivery-address-service";

export default {
  name: 'delivery-address-list',
  data() {
    return {
      sortBy: 'id',
      sortDesc: false,
      fields: [
        {
          key: 'id', label: 'ID', sortable: true
        },
        {
          key: 'street', label: 'Улица', sortable: true
        },
        {
          key: 'building', label: 'Здание', sortable: true
        },
        {
          key: 'flat', label: 'Квартира', sortable: true
        },
        {
          key: 'interaction', label: 'Взаимодействие'
        }
      ],
      deliveryAddressList: {
        perPage: 10,
        currentPage: 1,
        totalCount: 0,
      }
    };
  },
  created() {
    document.title = this.$route.meta.title;
  },
  methods: {
    getDeliveryAddressList(context) {
      return deliveryAddressService.getDeliveryAddressList(this.$route.params.id, context.perPage, context.currentPage, context.sortBy,
          context.sortDesc ? "Descending" : "Ascending")
          .then(response => {
            this.deliveryAddressList.totalCount = response.data.totalCount;
            return response.data.deliveryAddressList;
          })
          .catch(error => {
            this.$bvToast.toast('Не удалось загрузить адреса доставки пользователя' + (error.response == null ? '' : ` (код ${error.response.status})`), {
              title: 'Ошибка',
              variant: 'danger',
              autoHideDelay: 5000,
              appendToast: true
            });
          });
    },
    goToDetailPage(addressId) {
      this.$router.push(`/users/${this.$route.params.id}/delivery-address/${addressId}`);
    }
  }
}
</script>
